import React, { useState, useEffect } from "react";

import close from "../../../assets/icons/close.svg";
import plus1 from "../../../assets/icons/plus1.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../Components/LoaderAndSpinner/Loader";
import { useDispatch } from "react-redux";
import { fetchMenuItems } from "../../../Redux/Menu/MenuSlice";
import fetchWrapper from "../../../AuthMiddleware/FetchWrapper";
import { useNavigate } from "react-router-dom";

const EditModal = ({ show, handleClose, master, onEdit, parameters }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    master_name: "",
    slug: null,
    display_name_singular: "",
    display_name_plural: "",
    icon: null,
    model_name: "",
    parameter_type_id: "",
    order: "",
    masterFields: [
      {
        field_name: "",
        field_type: "",
        display_name: "",
        required: "",
        tooltip: "",
        default: "",
        is_unique: "",
        order: 1,
      },
    ],
  });

  const [isFieldNameValid, setIsFieldNameValid] = useState(true);
  const [errors, setErrors] = useState({});

  const validateFieldName = (value) => /^[a-z_]*$/.test(value);

  useEffect(() => {
    setIsFieldNameValid(true);
    setErrors({});
    if (master) {
      setFormData({
        master_name: master.master_name || "",
        slug: master.slug || null,
        display_name_singular: master.display_name_singular || "",
        display_name_plural: master.display_name_plural || "",
        icon: master.icon || null,
        model_name: master.model_name || "",
        parameter_type_id: master.parameter_type_id || "",
        order: master.order || "",
        masterFields: master.masterFields.map((field) => ({ ...field })),
      });
    }
  }, [master]);

  const stringToSlug = (str) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_");
  };

  const handleChange = (e, index = null, section = null) => {
    e.preventDefault();
    const { name, value } = e.target;

    const numericValue = Number(value);
    if (!isNaN(numericValue) && numericValue < 0) return;

    if (section === "masterFields") {
      const updatedFields = formData.masterFields.map((field, idx) => {
        if (idx === index) {
          const updatedField = { ...field, [name]: value };

          if (name === "display_name") {
            updatedField.field_name = stringToSlug(value);
          }

          if (name === "default" && value === "true") {
            updatedField.required = "true";
            updatedField.is_unique = "true";
          }

          if (name === "default" && value === "false") {
            updatedField.is_unique = "false";
          }

          return updatedField;
        }
        return field;
      });

      setFormData((prev) => ({ ...prev, masterFields: updatedFields }));

      if (name === "field_name") {
        setIsFieldNameValid(validateFieldName(value));
      }
    } else if (section === "masterdata") {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAddField = (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      masterFields: [
        ...prev.masterFields,
        {
          field_name: "",
          field_type: "",
          display_name: "",
          required: "",
          default: "",
          is_unique: "",
          tooltip: "",
          order: prev.masterFields.length + 1,
        },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    setFormData((prev) => ({
      ...prev,
      masterFields: prev.masterFields.filter((_, idx) => idx !== index),
    }));
  };

  const closeFunction = () => {
    setErrors({});
    setFormData({
      master_name: master.master_name || "",
      slug: master.slug || null,
      display_name_singular: master.display_name_singular || "",
      display_name_plural: master.display_name_plural || "",
      icon: master.icon || null,
      model_name: master.model_name || "",
      parameter_type_id: master.parameter_type_id || "",
      order: master.order || "",
      masterFields: master.masterFields.map((field) => ({ ...field })),
    });
    handleClose();
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { master_name, slug, display_name_singular, display_name_plural, icon, model_name, parameter_type_id, order, masterFields } = formData;

    const defaultTrueCount = masterFields.filter((f) => f.default === "true" || f.default === true).length;
    if (defaultTrueCount !== 1) {
      setLoading(false);
      toast.error("At most only one field can be set as default.");
      setErrors({
        masterFields: {
          default: "Only one field can have the default value set to 'true'.",
        },
      });
      return;
    }

    const masterData = { master_name, slug, display_name_singular, display_name_plural, icon, model_name, parameter_type_id, order };
    const masterFieldData = masterFields.map((f) => ({
      field_name: f.field_name,
      field_type: f.field_type,
      display_name: f.display_name,
      required: f.required,
      tooltip: f.tooltip,
      default: f.default,
      is_unique: f.is_unique,
      order: f.order,
    }));

    const requestData = { masterData, masterFieldData };

    try {
      await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/masters/update/${master._id}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
        navigate
      );

      setLoading(false);
      onEdit();
      dispatch(fetchMenuItems());
      toast.success("Master updated successfully");
      handleClose();
      setErrors({});
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error(error.response?.message || "Failed to update master");
      setErrors(error.response?.errors || {});
    }
  };

  return (
    <div id="overlay" className={`modal fade ${show ? "show" : ""}`} tabIndex="-1" role="dialog" style={{ zIndex: 30, display: show ? "block" : "none" }}>
      {loading ? <Loader /> : (
        <div>
          <div className="addunit-card Width 25%">
            <form onSubmit={handleSave} noValidate autoComplete="off">
              <div className="addunit-header">
                <h4>Edit Master</h4>
                <button type="button" className="close" style={{ border: "none", backgroundColor: "inherit" }} onClick={handleClose}>
                  <img src={close} width="28px" height="28px" alt="Close" />
                </button>
              </div>

              <div className="addunit-form" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                {/* Master Name */}
                <div className="row mb-4">
                  <div className="col">
                    <div className="d-flex flex-column">
                      <label className="addunit-form-text">Master Name<span className="text-danger">*</span></label>
                      <input type="text" name="master_name" value={formData.master_name} onChange={(e) => handleChange(e, null, "masterdata")} className="form-control" />
                    </div>
                  </div>
                </div>

                {/* Display Names */}
                <div className="row mb-4">
                  <div className="col">
                    <label className="addunit-form-text">Display Name Singular<span className="text-danger">*</span></label>
                    <input type="text" name="display_name_singular" value={formData.display_name_singular} onChange={(e) => handleChange(e, null, "masterdata")} className="form-control" />
                  </div>
                  <div className="col">
                    <label className="addunit-form-text">Display Name Plural<span className="text-danger">*</span></label>
                    <input type="text" name="display_name_plural" value={formData.display_name_plural} onChange={(e) => handleChange(e, null, "masterdata")} className="form-control" />
                  </div>
                </div>

                {/* Parameter Type + Order in same row */}
                <div className="row mb-4">
                  <div className="col">
                    <label className="addunit-form-text">Parameter Type<span className="text-danger">*</span></label>
                    <select name="parameter_type_id" value={formData.parameter_type_id} onChange={(e) => handleChange(e, null, "masterdata")} className="form-select select-unit textarea">
                      <option value="" disabled>Select Parameter Type</option>
                      {parameters.map((p) => <option key={p._id} value={p._id}>{p.parameter_type_name}</option>)}
                    </select>
                  </div>
                  <div className="col">
                    <label className="addunit-form-text">Order<span className="text-danger">*</span></label>
                    <input type="number" name="order" value={formData.order} onChange={(e) => handleChange(e, null, "masterdata")} className="form-control" />
                  </div>
                </div>

                <hr />

                {/* Master Fields */}
                <h5>Master Fields</h5>
                {formData.masterFields.map((field, index) => (
                  <div key={index}>
                    {formData.masterFields.length > 1 && (
                      <div className="row">
                        <div className="d-flex justify-content-end col-md-12">
                          <button type="button" className="close" style={{ border: "none", backgroundColor: "inherit" }} onClick={() => handleRemoveField(index)}>
                            <img src={close} width="28px" height="28px" alt="Close" />
                          </button>
                        </div>
                      </div>
                    )}
                    {/* Field Type + Display Name */}
                    <div className="row mb-4">
                      <div className="col">
                        <label className="addunit-form-text">Field Type<span className="text-danger">*</span></label>
                        <select name="field_type" value={field.field_type} onChange={(e) => handleChange(e, index, "masterFields")} className="form-select select-unit textarea">
                          <option value="" disabled>Select Field Type</option>
                          <option value="String">String</option>
                          <option value="Number">Number</option>
                          <option value="Date">Date</option>
                        </select>
                      </div>
                      <div className="col">
                        <label className="addunit-form-text">Display Name<span className="text-danger">*</span></label>
                        <input type="text" name="display_name" value={field.display_name} onChange={(e) => handleChange(e, index, "masterFields")} className="form-control" />
                      </div>
                    </div>

                    {/* Field Name + Order */}
                    <div className="row mb-4">
                      <div className="col">
                        <label className="addunit-form-text">Field Name<span className="text-danger">*</span></label>
                        <input type="text" name="field_name" value={field.field_name} readOnly className="form-control" />
                      </div>
                      <div className="col">
                        <label className="addunit-form-text">Order<span className="text-danger">*</span></label>
                        <input type="number" name="order" value={field.order} onChange={(e) => handleChange(e, index, "masterFields")} className="form-control" />
                      </div>
                    </div>

                    {/* Default + Required */}
                    <div className="row mb-4">
                      <div className="col">
                        <label className="addunit-form-text">Is Default<span className="text-danger">*</span></label>
                        <select name="default" value={field.default} onChange={(e) => handleChange(e, index, "masterFields")} className="form-select select-unit textarea">
                          <option value="" disabled>Select Yes or No</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                      <div className="col">
                        <label className="addunit-form-text">Is Required<span className="text-danger">*</span></label>
                        <select name="required" value={field.required} onChange={(e) => handleChange(e, index, "masterFields")} disabled={field.default === "true"} className="form-select select-unit textarea">
                          <option value="" disabled>Select Yes or No</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    </div>

                    {/* Is Unique + Tooltip */}
                    <div className="row mb-4">
                      <div className="col">
                        <label className="addunit-form-text">Is Unique<span className="text-danger">*</span></label>
                        <select name="is_unique" value={field.is_unique} onChange={(e) => handleChange(e, index, "masterFields")} disabled={field.default === "true"} className="form-select select-unit textarea">
                          <option value="" disabled>Select Yes or No</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                      <div className="col">
                        <label className="addunit-form-text">Tooltip<span className="text-danger">*</span></label>
                        <input type="text" name="tooltip" value={field.tooltip} onChange={(e) => handleChange(e, index, "masterFields")} className="form-control" />
                      </div>
                    </div>

                    <hr />
                  </div>
                ))}
                <button type="button" className="btn-bg" onClick={handleAddField}>
                  <span className="plus-icon"><img src={plus1} alt="Plus Icon" /></span> ADD Field
                </button>
              </div>

              <div className="addunit-card-footer justify-content-between">
                <button type="button" className="discard-btn" onClick={closeFunction}>Close</button>
                <button type="submit" className="update-btn" disabled={!isFieldNameValid} style={{ backgroundColor: !isFieldNameValid ? "lightgray" : "" }}>Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditModal;
